// Repris de reca-app-v3 `src/features/markers/domain/fieldMarkerTask.ts` (cap de déplacement de la carte).

export interface GeoPoint {
  lat: number
  lng: number
}

const earthRadiusMeters = 6_371_000
const toRadians = (degrees: number) => (degrees * Math.PI) / 180

export function distanceMeters(from: GeoPoint, to: GeoPoint): number {
  const dLat = toRadians(to.lat - from.lat)
  const dLng = toRadians(to.lng - from.lng)
  const a = Math.sin(dLat / 2) ** 2 + Math.cos(toRadians(from.lat)) * Math.cos(toRadians(to.lat)) * Math.sin(dLng / 2) ** 2
  return 2 * earthRadiusMeters * Math.asin(Math.min(1, Math.sqrt(a)))
}

export function bearingDegrees(from: GeoPoint, to: GeoPoint): number {
  const dLng = toRadians(to.lng - from.lng)
  const lat1 = toRadians(from.lat)
  const lat2 = toRadians(to.lat)
  const y = Math.sin(dLng) * Math.cos(lat2)
  const x = Math.cos(lat1) * Math.sin(lat2) - Math.sin(lat1) * Math.cos(lat2) * Math.cos(dLng)
  return ((((Math.atan2(y, x) * 180) / Math.PI) % 360) + 360) % 360
}

export function unwrapAngle(current: number, target: number): number {
  const delta = ((((target - current) % 360) + 540) % 360) - 180
  return current + delta
}

/** La carte a-t-elle réellement pris ce cap ? (Google ignore `setHeading` sur une carte matricielle.) */
export function headingApplied(actual: number | undefined, requested: number, toleranceDeg = 1): boolean {
  if (actual === undefined) return false
  return Math.abs(((((actual - requested) % 360) + 540) % 360) - 180) <= toleranceDeg
}

export function smoothHeading(previous: number | null, next: number, factor = 0.4): number {
  if (previous === null) return next
  const delta = ((((next - previous) % 360) + 540) % 360) - 180
  return (((previous + delta * factor) % 360) + 360) % 360
}
